import React from "react";

export const FeedbackIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.84816 4.24351C1.6665 4.60003 1.6665 5.06674 1.6665 6.00016V6.50016C1.6665 7.43358 1.6665 7.90029 1.84816 8.25681C2.00795 8.57042 2.26292 8.82539 2.57652 8.98517C2.93304 9.16683 3.39975 9.16683 4.33317 9.16683H15.6665C16.5999 9.16683 17.0666 9.16683 17.4232 8.98517C17.7368 8.82539 17.9917 8.57042 18.1515 8.25681C18.3332 7.90029 18.3332 7.43358 18.3332 6.50016V6.00016C18.3332 5.06674 18.3332 4.60003 18.1515 4.24351C17.9917 3.92991 17.7368 3.67494 17.4232 3.51515C17.0666 3.3335 16.5999 3.3335 15.6665 3.3335H4.33317C3.39975 3.3335 2.93304 3.3335 2.57652 3.51515C2.26292 3.67494 2.00795 3.92991 1.84816 4.24351ZM5.4165 5.41683H3.74984V7.0835H5.4165V5.41683Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.84816 11.7435C1.6665 12.1 1.6665 12.5667 1.6665 13.5002V14.0002C1.6665 14.9336 1.6665 15.4003 1.84816 15.7568C2.00795 16.0704 2.26292 16.3254 2.57652 16.4852C2.93304 16.6668 3.39975 16.6668 4.33317 16.6668H15.6665C16.5999 16.6668 17.0666 16.6668 17.4232 16.4852C17.7368 16.3254 17.9917 16.0704 18.1515 15.7568C18.3332 15.4003 18.3332 14.9336 18.3332 14.0002V13.5002C18.3332 12.5667 18.3332 12.1 18.1515 11.7435C17.9917 11.4299 17.7368 11.1749 17.4232 11.0152C17.0666 10.8335 16.5999 10.8335 15.6665 10.8335H4.33317C3.39975 10.8335 2.93304 10.8335 2.57652 11.0152C2.26292 11.1749 2.00795 11.4299 1.84816 11.7435ZM5.4165 12.9168H3.74984V14.5835H5.4165V12.9168Z"
      fill="currentColor"
    />
  </svg>
);
